import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as marketsActions from '../actions/marketsActions';
import * as companiesActions from '../actions/companiesActions';
import * as appActions from '../actions/appActions';

import { getTradePermissions, setTradePermissions, setTradePermissionsAll } from '../services/api';

import MarketSelector from '../components/marketSelector';
import Checkbox from '../components/customCheckbox';
import CompanySelector from '../components/CompanySelector';

class screenComponent extends React.Component {
    constructor(props) {
		super(props);

        this.initialState = {
            filterTable: {},
            market_id: ''
        }
        this.state = this.initialState;

        this.fetched = false;
        this.getCompanies = this.getCompanies.bind(this);
        this.initialLoad = this.initialLoad.bind(this);
        this.getFilterTable = this.getFilterTable.bind(this);
        this.onChangeMarket = this.onChangeMarket.bind(this);
	}

    componentDidMount() {
        if (!this.props.markets.data.length) {
            this.props.actions.getMarketsList();
        }
        this.initialLoad(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.initialLoad(nextProps);
    }

    initialLoad(props) {
        if (!this.state.market_id && props.markets.data.length) {
            this.setState({
                market_id: props.markets.data[0].id
            }, this.getFilterTable);
        }
    }

    getFilterTable(refresh) {
        if (!this.fetched || refresh ) {
            const market_id = this.state.market_id;
            this.props.actions.showProgress();
            getTradePermissions(market_id).then( resp => {
                let newState = {
                    filterTable: this.transformFilterTable(resp.data)
                }
                this.props.actions.getApprovedCompanies( this.setState(newState), market_id );
                this.fetched = true;
                this.props.actions.hideProgress();
            }).catch( er => console.log(er) );
        }
    }

    transformFilterTable(data) {
        let result = {};

        data.map( item => {
            result[item.comp1] = {
                ...result[item.comp1],
                [item.comp2]: {
                    blocked: true
                }
            }
        });
        
        return result;
    }

    getCompanies() {
        return this.props.companies.companiesApproved;
    }

    onChangeMarket(e) {
        const value = e.target.value;

        this.setState({
            ...this.state,
            market_id: value,
        }, ()=>this.getFilterTable(true) )
    }

    render() {
        const { markets, user } = this.props,
        { isLoggedIn, isSuperUser, isAdmin } = user;
        if (!(isLoggedIn && (isSuperUser || isAdmin))) return false;

        return (
            <div>
                <div className='indices-header'>
                    <h1>Manage counter party filter</h1>
                    <h3>The companies with checkmarks may trade with each other</h3>
                    <div className='indices-market-selector-holder'>
                        <div className='indices-market-selector-label'>Select market</div>

                        <MarketSelector
                            onChange={this.onChangeMarket}
                            value={this.state.market_id}
                            list={markets.data} />

                    </div>
                </div>

                <MarketSection
                    showProgress={this.props.actions.showProgress}
                    hideProgress={this.props.actions.hideProgress}
                    fetching={this.props.companies.fetching}
                    filterTable={this.state.filterTable}
                    marketId={this.state.market_id}
                    refresh={()=>this.getFilterTable(true)}
                    companies={this.getCompanies()} />

            </div>
        )
    }
}

class MarketSection extends React.Component {
    constructor(props) {
		super(props);
        this.state = {
            fixedHeader: false,
            selectedCompanies: []
        }
        this.startScrolling = false;
        this.justInitialized = true;
        this.headerOffset = 0;
        this.headerHeight = 0;
        this.resetHeader = this.resetHeader.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.addCompany = this.addCompany.bind(this);
	}

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, true);
        window.addEventListener('resize', this.handleResize, true);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }

    shouldComponentUpdate(nextProps, nextState) {      
        return !this.startScrolling ||
            nextProps != this.props ||
            nextState.tableWidth != this.state.tableWidth ||
            nextState.fixedHeader != this.state.fixedHeader ||
            nextState.selectedCompanies != this.state.selectedCompanies;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.marketId != this.props.marketId) {
            this.resetHeader();
            this.setState({ selectedCompanies: [] });
        }
    }

    resetHeader() {
        this.startScrolling = false;
        this.headerOffset = 0;
        this.headerHeight = 0;
        this.setState({
            fixedHeader: false,
            tableWidth: 'auto'
        });
    }

    handleScroll(e) {
        let { scrollTop } = e.target;
        if (!this.startScrolling) {
            this.headerOffset = this.thead.getBoundingClientRect().top;
            this.headerHeight = this.thead.offsetHeight;
            this.tableWidth = this.table.getBoundingClientRect().width;
            this.setState({
                tableWidth: this.table.getBoundingClientRect().width+'px',
            });
        }
        this.startScrolling = true;
        this.setState({
            fixedHeader: e.target.scrollTop >= this.headerOffset,
        });
    }

    handleResize() {
        this.setState({
            tableWidth: this.table.getBoundingClientRect().width+'px',
        });
    }

    onChange(comp1, comp2) {
        const blocked = this.isExists(comp1, comp2);
        const param = { comp1, comp2, blocked };

        this.props.showProgress();
        setTradePermissions(param).then(() => {
            this.props.hideProgress();
            this.props.refresh();
        }).catch(er => console.log(er));
    }

    isExists(id1, id2) {
        const { filterTable } = this.props;

        return ((id1 in filterTable && id2 in filterTable[id1]) || (id2 in filterTable && id1 in filterTable[id2]));
    }

    areAllSelected(id) {
        const { filterTable, companies } = this.props;

        return companies.find(comp => this.isExists(id, comp.id)) ? false : true;
    }

    onChangeAll(id) {
        const { companies } = this.props;
        const blocked = this.areAllSelected(id);
        const params = {
            comp1: id,
            blocked,
            comp2: companies.map(comp => comp.id)
        };

        this.props.showProgress();
        setTradePermissionsAll(params).then(() => {
            this.props.hideProgress();
            this.props.refresh();
        }).catch(er => console.log(er));
    }

    getTdWidth(length) {
        return { width: `calc(100% / ${length})` }
    }

    addCompany(companyId) {
        const selectedCompanies = [ ...this.state.selectedCompanies ];

        if (selectedCompanies.indexOf(companyId) < 0) {
            selectedCompanies.push(companyId);            
            this.setState({ selectedCompanies });
        }
    }

    renderNoCompanySelected() {        
        return (
            <div className='counter-party-wrapper'> 
                <CompanySelector companies={this.props.companies} addCompany={this.addCompany}/>                               
                <div className='counterparty table overlayed'>
                    <div className='thead'>
                        <div className='counterparty-label-holder'>&nbsp;</div>
                        <div className='counterparty-cells-holder'>
                            {Array(5).fill(5).map((_, i) => 
                                <div className='cell' title='Company name' style={this.getTdWidth(5)} key={'comp_head_item' + i}>
                                    <div className='tilted'><span>Company name</span></div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='tbody'>
                        {Array(5).fill(5).map((_, i) => 
                            <div className='row' key={'comp_row_item'+i}>
                                <div className='counterparty-label-holder'>Company name</div>
                                <div className='counterparty-cells-holder'>
                                    {Array(5).fill(5).map((_, j) => 
                                        <div className='cell' style={this.getTdWidth(5)} key={'chbox'+i+'_'+j}>
                                            <Checkbox checked={true} onChange={()=>{}} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='overlay'>Please select a company</div>
                </div>
            </div>
        )
    }

    render() {
        const { market, companies } = this.props;
        const { selectedCompanies, fixedHeader, tableWidth } = this.state;
        
        if (!selectedCompanies.length) {
            return this.renderNoCompanySelected();
        }

        const columnCompanies = companies.slice().filter(comp => selectedCompanies.indexOf(comp.id) > -1);
        const allCompanies = companies.slice();

        return (
            <div className='counter-party-wrapper'> 
                <CompanySelector companies={companies} addCompany={this.addCompany}/>
                <div className={'counterparty table '+(fixedHeader ? 'fixedHeader' : '')} ref={node => this.table = node}>
                    <div className='thead' style={{width: tableWidth}} ref={node => this.thead = node}>
                        <div className='counterparty-label-holder'>&nbsp;</div>
                        <div className='counterparty-cells-holder'>
                        {columnCompanies.map(item =>
                            <div className='cell' title={item.name}
                                style={this.getTdWidth(columnCompanies.length)} key={'comp_head_item'+item.id}>
                                <div className='tilted'>
                                    <span>{item.name}</span>
                                </div>
                            </div>
                        )}
                        </div>
                    </div>
                    <div style={{marginTop: fixedHeader ? this.headerHeight+'px' : '0px'}} className='tbody'>
                        <div className='row all'>
                            <div className='counterparty-label-holder'>Select/Deselect all</div>
                            <div className='counterparty-cells-holder'>
                                {columnCompanies.map((el, j) =>
                                    <div className='cell' style={this.getTdWidth(columnCompanies.length)} key={'chboxall_'+j}>                                        
                                        <Checkbox checked={this.areAllSelected(el.id)} onChange={()=>this.onChangeAll(el.id)} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {allCompanies.map((item, i) =>
                            <div className='row' key={'comp_row_item'+item.id}>
                                <div className='counterparty-label-holder'>{item.name}</div>
                                <div className='counterparty-cells-holder'>
                                {columnCompanies.map((el, j) =>
                                    <div className='cell' style={this.getTdWidth(columnCompanies.length)} key={'chbox'+item.id+'_'+j}>
                                        {item.id !== el.id ?
                                            <Checkbox checked={!this.isExists(item.id, el.id)} onChange={()=>this.onChange(item.id, el.id)} />
                                        : null}
                                    </div>
                                )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}


export default connect(
    state => ({
        markets: state.markets,
        companies: state.companies,
        user: state.user,
    }),
    dispatch => ({
        actions: bindActionCreators({...marketsActions, ...companiesActions, ...appActions}, dispatch)
    })
)(screenComponent);



// WEBPACK FOOTER //
// ./source/screens/ManageCounterPartyFilter.js